/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native-web';
import { connect } from 'react-redux';
import { ICartProduct, IShippingAddress } from '@ddot/AddToCartCommon/lib/entities';
import { IGoldPrice } from 'Redux/slices/home/Entities';
import Actions from 'Redux/Actions';

import CartBreadcrumbs from 'Containers/Cart/Components/CartBreadcrumbs';
import { Container, Row, Card, CardBody, Col, Input, Label, Button } from 'reactstrap';

import Selectors from 'Redux/Selectors';
import { RootState } from 'Redux/store';

import Utils from 'Lib/Utils';

import NavActions from 'Services/Navigation/Actions';

import { Bank, FPXIcon, Visa, RightArrow, AtmCard } from 'Icons/Icons';
import Toast from 'Lib/Toast';
import { IEGHLInfo } from '@ddot/AddToCartCommon/lib/redux';
import { sha256 } from 'js-sha256';
import Config from 'Config/Config';
import AssistanceNumber from './Components/AssistanceNumber';
import CreditCardPayment from './Components/CreditCardPayment';
import OrderSummary from './Components/OrderSummary';
import GoldPriceChangeAlert from './Components/GoldPriceChangeAlert';
import {
    continuePaymentButton,
} from './Styles/ShippingAddressStyles';
import {
    cartContainer,
    cartTitle,
    divider,
    paymentMethodCard,
    paymentCardLabel,
    paymentCardLabelSelected,
    paymentMethodIcon,
    paymentMethodLabel,
    inputRadio,
} from './Styles/CartStyles';

interface PaymentProps {
    cartItems: ICartProduct[];
    shippingAddress?: IShippingAddress;
    loading: boolean;
    shippingFee: number;
    goldPrice: IGoldPrice;
    orderId: string;
    orderShortId: string;
    getCyberSourceInfo(orderId: string): void;
    getEGHLInfo: IEGHLInfo;
    setEGHLInfo: (info: IEGHLInfo) => void;
    getPaymentID: (orderId: string) => {
        payload: string;
    };
}

const PaymentScreen = (props: PaymentProps): JSX.Element => {
    const {
        cartItems, shippingAddress, loading, shippingFee, goldPrice, orderId, orderShortId, getCyberSourceInfo,
        getEGHLInfo, setEGHLInfo, getPaymentID,
    } = props;

    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentError, setPaymentError] = useState('');
    const [loadingPaymentId, setLoadingPaymentId] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => { NavActions.navToHome(); }, 600000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    const callGetPaymentID = async () => {
        setLoadingPaymentId(true);
        const id = await getPaymentID(orderId);

        return id.payload;
    };

    let total = 0;

    cartItems.forEach(item => {
        const { selectedVariant, quantity } = item;
        const variantPrice = Utils.Jemisys.getItemVariantPrice(item, selectedVariant, goldPrice);
        total += (variantPrice * quantity);
    });

    const orderSummary = {
        subTotal: total,
        currency: 'MYR',
        promoCode: null,
        discountPrice: 0,
        totalCost: total + shippingFee,
        shippingFee,
    };

    // const paymentMethods = ['Bank Transfer', 'Credit or Debit Card', 'FPX Online Banking'];
    // const paymentMethods = ['Credit/Debit Card', 'FPX Online Banking'];
    const paymentMethods = ['Credit Card', 'Debit Card'];

    // const renderPaymentMethodIcons = (item: string) => {
    //     if (item === 'Bank Transfer') {
    //         return <Bank css={paymentMethodIcon} />;
    //     } if (item === 'Credit/Debit Card') {
    //         return <Visa css={paymentMethodIcon} />;
    //     } if (item === 'FPX Online Banking') {
    //         return <FPXIcon css={paymentMethodIcon} />;
    //     } return false;
    // };

    const renderPaymentMethodIcons = (item: string) => {
        if (item === 'Credit Card') {
            return <AtmCard css={paymentMethodIcon} />;
        } if (item === 'Debit Card') {
            return <Visa css={paymentMethodIcon} />;
        } if (item === 'FPX Online Banking') {
            return <FPXIcon css={paymentMethodIcon} />;
        } return false;
    };

    const renderPaymentMethodChoices = () => {
        return paymentMethods.map(item => {
            return (
                <Card key={item} css={paymentMethodCard}>
                    <CardBody style={{ padding: 0 }}>
                        <Label css={paymentMethod === item ? paymentCardLabelSelected : paymentCardLabel} for={item}>
                            <div>
                                <Input css={inputRadio} onClick={() => setPaymentMethod(item === 'Credit Card' ? 'CC' : 'DD')} type='radio' name='paymentMethod' id={item} />
                                <p css={paymentMethodLabel}>{item === 'FPX Online Banking' ? 'Online Banking' : item}</p>
                            </div>
                            {renderPaymentMethodIcons(item)}
                        </Label>
                    </CardBody>
                </Card>
            );
        });
    };

    const renderPaymentMethodDetails = () => {
        // if (paymentMethod === 'Bank Transfer') {
        //     return <BankTransfer />;
        // }
        // if (paymentMethod === 'FPX Online Banking') {
        //     return <FPX />;
        // }
        if (paymentMethod === 'Credit/Debit Card') {
            return <CreditCardPayment />;
        } return false;
    };

    const renderPaymentGateway = () => {
        return (
            <Card css={paymentMethodCard}>
                <CardBody style={{ padding: 0 }}>
                    <Label css={paymentMethod === 'eGHL' ? paymentCardLabelSelected : paymentCardLabel}>
                        <div style={{ flex: 1 }}>
                            <Input css={inputRadio} onClick={() => setPaymentMethod('eGHL')} type='radio' name='paymentMethod' id='eGHL' />
                            <p css={paymentMethodLabel}>eGHL </p>
                        </div>
                        <div>
                            <img src='/eGHL_Logo.png' alt='' style={{ width: 50, height: 'auto' }} />
                        </div>
                    </Label>
                </CardBody>
            </Card>
        );
    };

    const getEGHLHashValue = async (pymtID: string) => {
        const hashKey = `${Config.MERCHANT_KEY}${getEGHLInfo.ServiceID}${pymtID}${getEGHLInfo.MerchantReturnURL}${getEGHLInfo.MerchantCallBackURL}${getEGHLInfo.Amount}${getEGHLInfo.CurrencyCode}${getEGHLInfo.CustIP}${getEGHLInfo.PageTimeout}`;
        const hashVal = sha256(hashKey);

        return hashVal;
    };

    const onProceedClick = async () => {
        if (!paymentMethod) {
            setPaymentError('Please select a payment method');
            return;
        }

        const paymentID = await callGetPaymentID();

        const hashValue = await getEGHLHashValue(paymentID);

        const upID = `${process.env.REACT_APP_UPSHOPID}`;

        setEGHLInfo({ ...getEGHLInfo, OrderNumber: orderShortId, PymtMethod: 'ANY', PaymentID: paymentID, HashValue: hashValue, Param6: upID });

        setLoadingPaymentId(false);

        NavActions.navToSubmitCyberSourceInfo();
    };

    return (
        <View style={{ minHeight: 570, marginBottom: 50 }}>
            <Container fluid css={cartContainer}>
                <CartBreadcrumbs currentItem={3} />
                <Row>
                    <Col xs={12} xl={8} style={{ marginTop: 40 }}>
                        <Row>
                            <Col>
                                <div css={cartTitle}>Select Payment Method</div>
                            </Col>
                        </Row>

                        <GoldPriceChangeAlert />

                        <Row style={{ minHeight: 100, marginTop: 35 }}>
                            {renderPaymentGateway()}
                        </Row>

                        {/* <Row style={{ minHeight: 100, marginTop: 35 }}> */}
                        {/* {renderPaymentMethodChoices()} */}
                        {/* <div css={divider} /> */}
                        {/* </Row> */}
                        {/* <Row style={{ padding: 0 }}>
                            {renderPaymentMethodDetails()}
                        </Row> */}
                        {paymentError && (
                            <Row>
                                <Col xs={12}>
                                    <div css={paymentError} style={{ color: 'red' }}>
                                        {paymentError}
                                    </div>
                                </Col>
                            </Row>
                        )}
                        <Row style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                onClick={onProceedClick}
                                css={continuePaymentButton}
                                disabled={loading || loadingPaymentId}
                            >
                                {loading || loadingPaymentId ? (
                                    // change loading selector
                                    <ActivityIndicator color='#064E72' />
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p style={{ margin: '0 10px 0 0' }}>Pay Now</p>
                                        <RightArrow />
                                    </div>
                                )}
                            </Button>
                        </Row>
                    </Col>
                    <Col xs={12} xl={4}>
                        <OrderSummary
                            data={orderSummary}
                            products={cartItems}
                        />
                        <AssistanceNumber mobileNumber='+60 16-773 0338' />
                    </Col>
                </Row>
            </Container>
        </View>
    );
};

PaymentScreen.defaultProps = {
    shippingAddress: undefined,
};

const mapStateToProps = (state: RootState) => ({
    loading: Selectors.getCartPlaceOrderAttempting(state),
    error: Selectors.getCartPlaceOrderError(state),
    cartItems: Selectors.getCartItems(state),
    cartCurrency: Selectors.getCartCurrency(state),
    userInfo: Selectors.getUserInfo(state),
    shippingFee: Selectors.getCartShippingFee(state),
    shippingAddress: Selectors.getCartShippingAddress(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
    orderId: Selectors.getUiOrderId(state),
    orderShortId: Selectors.getUiOrderShortId(state),
    getEGHLInfo: Selectors.getCartEGHLInfo(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    getFpxBankList: () => dispatch(Actions.cartGetFpxBankList()),
    getCyberSourceInfo: (orderId: string) => dispatch(Actions.cartGetCyberSourceInfo({ orderId })),
    setEGHLInfo: (info: IEGHLInfo) => dispatch(Actions.cartSetEGHLInfo(info)),
    getPaymentID: (orderId: string) => dispatch(Actions.cartGetPaymentId({ orderId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentScreen);
